module.exports = __webpack_public_path__ + "static/assets/cf19444715d6f74e337378c9826eacf0.svg";